import React from "react";
import { Typography, Link } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
   
    // paddingBottom: theme.spacing(3),
  },
  copyrightText: {
    color: "#ffffff",
    display: "flex",
    justifyContent: "space-between",
    // padding: theme.spacing(2, 0),
  },
}));

const Main = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography
        variant="body2"
        align="center"
        gutterBottom
        className={classes.copyrightText}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "18px",
          }}
        >
          {`Copyright © ${new Date().getFullYear()}     `}
          <Link color="inherit" href="https://booking.mobitill.com/">
            Mobitill Epesi Booking Platform
          </Link>{" "}
          <Link
            color="inherit"
            rel="noopener noreferrer"
            target="_blank"
            href="https://dataintegrated.co.ke/"
            style={{  textDecoration: "none" }}
          >
            A Product From
            <span style={{ marginLeft: "4px", marginRight: "4px", textDecoration: "underline" }}>
              MOBITILL GROUP{" "}
            </span>
          </Link>{" "}
        </div>
        <div 
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "18px",
          }}
        >
          <Link color="inherit" href="/terms">
            Terms and Conditions
          </Link>

          <Link color="inherit" href="/privacy">
            Privacy Policy
          </Link>
        </div>
      </Typography>
    </div>
  );
};

export default Main;
